module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/QpHqTO/Images/Cover.jpg?1727443813885",
      "alt": "This image is the cover for the book Trust"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Trust\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A MOST ANTICIPATED BOOK OF FALL 2021  Following the international success of Ties and the National Book Award-shortlisted Trick, Domenico Starnone gives readers another searing portrait of human relationships and human folly.  Pietro and Teresa’s love affair is tempestuous and passionate. After yet another terrible argument, she gets an idea: they should tell each other something they’ve never told another person, something they’re too ashamed to tell anyone. They will hear the other’s confessions without judgment and with love in their hearts. In this way, Teresa thinks, they will remain united forever, more intimately connected than ever.  A few days after sharing their shameful secrets, they break up. Not long after, Pietro meets Nadia, falls in love, and proposes. But the shadow of the secret he confessed to Teresa haunts him, and Teresa herself periodically reappears, standing at the crossroads, it seems, of every major moment in his life. Or is it he who seeks her out?  Starnone is a master storyteller and a novelist of the highest order. His gaze is trained unwaveringly on the fault lines in our public personas and the complexities of our private selves. Trust asks how much we are willing to bend to show the world our best side, knowing full well that when we are at our most vulnerable we are also at our most dangerous.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Domenico Starnone\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Europa Editions\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0